// extracted by mini-css-extract-plugin
export var chevron = "_ov-1";
export var clickable = "_ov-0";
export var ruleRow = "_ov-2";